import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Icon as MuiIcon } from '@mui/material';
import { forwardRef } from 'react';
import { useTheme } from '../../theme';
export const Icon = forwardRef(function Icon({ size = 'medium', variant, color }, ref) {
    const { sizes } = useTheme().components?.DSIcon ?? {};
    return (_jsx(Box, { color: color, children: _jsx(MuiIcon, { className: `zi zi-${variant}`, ref: ref, sx: {
                ...sizes?.[size],
                display: 'contents',
                '&::before': {
                    verticalAlign: 'middle',
                },
            } }) }));
});
